import React from "react";
import { Link } from "react-router-dom";
import { FaUserShield } from "react-icons/fa";

export default function TopBar({ isAuthed, onLogin, onLogout, userName, isAdmin }) {
  return (
    <div className="topbar" role="banner">
      <div className="brand">
        <img
          src={process.env.PUBLIC_URL + "/logo.png"}
          alt="Aegis logo"
          className="brandLogo"
          draggable="false"
        />
      </div>

      <div className="spacer" />

      {/* Administration is reached from here rather than the sidebar, so the
          sidebar stays identical for admins and regular users. */}
      {isAuthed && isAdmin && (
        <Link to="/admin" className="authBtn" aria-label="Administration" title="Administration">
          <FaUserShield className="person" aria-hidden />
          <span>Admin</span>
        </Link>
      )}

      <button
        className="authBtn"
        onClick={isAuthed ? onLogout : onLogin}
        aria-label={isAuthed ? "Logout" : "Login"}
      >
        <svg
          className="person"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="3" />
        </svg>
        <span>{isAuthed ? (userName ? `Logout (${userName})` : "Logout") : "Login"}</span>
      </button>
    </div>
  );
}
